const V5_GADGET_TYPES: GadgetType[] = [
  'rollingTrendCard',
  'fixedTrendCard',
  'smartCard',
  'card',
  'timeSeries',
  'pie',
  'bar',
  'horizontalBar',
  'simpleGrid',
  'treeMap',
  'combo',
  'matrix',
  'stackedArea',
  'stackedBar',
  'donut',
  'radar',
  'waterfall',
  'packedBubble',
  'scatter',
  'bubble',
  'heatmap',
  'funnel',
  'pyramid',
  'sankey',
];

export default V5_GADGET_TYPES;
